module.exports = __webpack_public_path__ + "img/document.771d598d.svg";